import ZpCard from './src/card.vue'

export default ZpCard
